import { APP_INITIALIZER, ErrorHandler, LOCALE_ID } from '@angular/core';
import { Router } from '@angular/router';

import {
  StatehandlerProcessorService,
  StatehandlerProcessorServiceImpl,
  StatehandlerService,
  StatehandlerServiceImpl,
  StorageService,
  UserPermissionsService,
} from '@praceprofirmy/system-domain';
import * as Sentry from '@sentry/angular';
import { AuthConfig, OAuthStorage } from 'angular-oauth2-oidc';
import { authConfig } from './auth.config';

export const serviceProviders = [
  {
    provide: AuthConfig,
    useValue: authConfig,
  },
  {
    provide: StatehandlerProcessorService,
    useClass: StatehandlerProcessorServiceImpl,
  },
  {
    provide: StatehandlerService,
    useClass: StatehandlerServiceImpl,
  },
  {
    provide: OAuthStorage,
    useClass: StorageService,
  },
  {
    provide: ErrorHandler,
    useValue: Sentry.createErrorHandler(),
  },
  {
    provide: Sentry.TraceService,
    deps: [Router],
  },
  {
    provide: APP_INITIALIZER,
    useFactory: () => () => {
      // Sentry trace initialization
      return Promise.resolve();
    },
    deps: [Sentry.TraceService],
    multi: true,
  },
  {
    provide: APP_INITIALIZER,
    useFactory: () => () => {
      // User permissions initialization
      return Promise.resolve();
    },
    deps: [UserPermissionsService],
    multi: true,
  },
  {
    provide: LOCALE_ID,
    useValue: 'cs-CZ',
  },
];
